import React, { useState } from 'react';
import { FaCheck, FaTimes, FaSpinner, FaShieldAlt } from 'react-icons/fa';
import ofertasService from '../../helpers/ofertasService';

const OfertaValidator = ({ ofertaId, clienteId, importeCompra, onValidation }) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const validateOferta = async () => {
        if (!ofertaId || !clienteId) {
            console.error('Faltan parámetros requeridos para validar oferta');
            return;
        }

        setLoading(true);
        try {
            const response = await ofertasService.validateOferta(ofertaId, {
                clienteId,
                importeCompra: importeCompra || 0
            });

            setResult(response);
            if (onValidation) {
                onValidation(response);
            }
        } catch (error) {
            console.error('Error validando oferta:', error);
            setResult({
                valida: false,
                mensaje: error.message || 'Error al validar la oferta'
            });
        } finally {
            setLoading(false);
        }
    };

    const getValidationIcon = () => {
        if (loading) {
            return <FaSpinner className="animate-spin text-blue-500" />;
        }

        if (result) {
            return result.valida ?
                <FaCheck className="text-green-500" /> :
                <FaTimes className="text-red-500" />;
        }

        return <FaShieldAlt className="text-gray-400" />;
    };

    const getValidationMessage = () => {
        if (loading) return 'Validando...';
        if (!result) return 'Pendiente de validación';
        return result.mensaje || (result.valida ? 'Oferta válida' : 'Oferta no válida');
    };

    const getValidationColor = () => {
        if (loading) return 'text-blue-600';
        if (!result) return 'text-gray-600';
        return result.valida ? 'text-green-600' : 'text-red-600';
    };

    const getValidationBg = () => {
        if (loading) return 'bg-blue-50';
        if (!result) return 'bg-gray-50';
        return result.valida ? 'bg-green-50' : 'bg-red-50';
    };

    return (
        <div className={`${getValidationBg()} p-2 rounded-lg border transition-all duration-200`}>
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-2 flex-1 min-w-0">
                    {getValidationIcon()}
                    <span className="text-xs font-medium text-gray-700 truncate">Estado de validación</span>
                </div>
                <button
                    onClick={validateOferta}
                    disabled={loading || !ofertaId || !clienteId}
                    className="px-3 py-1 bg-blue-500 text-white text-xs rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium flex-shrink-0 ml-2"
                >
                    {loading ? 'Validando...' : 'Validar'}
                </button>
            </div>

            <div className="space-y-1">
                <div className="flex justify-between items-center text-xs">
                    <span className="text-gray-600">Importe actual:</span>
                    <span className="font-semibold text-gray-800">{importeCompra || 0}€</span>
                </div>

                {result && (
                    <div className={`p-1.5 rounded border ${result.valida ? 'border-green-200 bg-green-100' : 'border-red-200 bg-red-100'}`}>
                        <p className={`text-xs font-medium ${getValidationColor()} break-words`}>
                            {getValidationMessage()}
                        </p>
                        {result.valida && result.descuentoAplicable && (
                            <p className="text-xs text-green-700 mt-0.5 font-medium">
                                💰 Descuento: {result.descuentoAplicable}€
                            </p>
                        )}
                    </div>
                )}

                {!result && !loading && (
                    <p className="text-xs text-gray-500 italic break-words">
                        Haz clic en "Validar" para verificar si puedes aplicar esta oferta
                    </p>
                )}
            </div>
        </div>
    );
};

export default OfertaValidator; 